import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-frame',
  templateUrl: './video-frame.component.html',
  styleUrls: ['./video-frame.component.scss']
})
export class VideoFrameComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

}
